import { Button as BaseButton } from "@base-ui/react/button";
import type { ComponentProps, ElementType } from "react";
// @ts-expect-error pure js
import Spinner from "./Spinner";
import styles from "./Button.module.css";
// @ts-expect-error pure js
import { classnames } from "../../utils";
import Tooltip from "./Tooltip";
import useCanWrite from "../../hooks/use-can-write";
import { READ_ONLY_MESSAGE } from "../../utils/permissions";

type ButtonVariant = "primary" | "secondary" | "tertiary" | "danger";
type ButtonSize = "md" | "sm";

interface ButtonProps extends ComponentProps<typeof BaseButton> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  isLoading?: boolean;
  icon?: ElementType;
  requiresWrite?: boolean;
  profileId?: number | null;
}

export default function Button({
  variant = "primary",
  size = "md",
  icon: Icon,
  className,
  children,
  disabled,
  isLoading,
  requiresWrite,
  profileId,
  ...props
}: ButtonProps) {
  const writable = useCanWrite(profileId);
  const blocked = requiresWrite === true && !writable;

  const button = (
    <BaseButton
      className={classnames(
        styles.button,
        styles[variant],
        styles[size],
        className,
      )}
      disabled={blocked || (disabled ?? isLoading)}
      {...props}
    >
      {isLoading && (
        <div>
          <Spinner />
        </div>
      )}
      {Icon && <Icon size={size === "sm" ? 16 : 20} />}
      {children}
    </BaseButton>
  );

  if (blocked) {
    return <Tooltip content={READ_ONLY_MESSAGE}>{button}</Tooltip>;
  }
  return button;
}
